function ItemsList() {
  return (
    <div>
      <h2>Items List</h2>
      <p>Your complete information comes here.</p>
    </div>
  );
}

export default ItemsList;